"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var throttle_1 = require("utils/throttle");
var smartimagesrc_1 = require("@ezbuy/smartimagesrc");
var tool_1 = require("mobile/utils/tool");
var tool_2 = require("../../tool");
var WithEZSpm_1 = require("components/WithEZSpm");
var tyrande_1 = require("tyrande");
var mutil_Language_1 = require("mobile/utils/mutil-Language");
var ss = require("./index.scss");
var arrowPoster = smartimagesrc_1.makeImageUrls("https://i.ezbuy.sg/FipFPHV0jCuBeo8YBQgig1oJtL6m", {
    online: true
})[0];
var Nav = (function (_super) {
    __extends(Nav, _super);
    function Nav(props) {
        var _this = _super.call(this, props) || this;
        _this.itemList = [];
        _this.scroll = function (event) {
            var _a = _this.props, hasTitle = _a.hasTitle, navFixed = _a.navFixed, moduleMap = _a.moduleMap, topMap = _a.topMap, index = _a.index;
            if (navFixed) {
                var scrollTop = (event.srcElement ? event.srcElement.documentElement.scrollTop : false) ||
                    window.pageYOffset ||
                    (event.srcElement ? event.srcElement.body.scrollTop : 0);
                var navTopValue = tool_2.navFixNum(hasTitle);
                var topValue_1 = tool_2.moduleNum(hasTitle, navFixed);
                if (_this.navList && scrollTop >= topMap[index].offsetTop - tool_1.getPxByRem(navTopValue)) {
                    _this.setState({
                        scrollFixed: true
                    });
                    var arr = moduleMap.filter(function (ele) {
                        if (ele.item && ele.item.getBoundingClientRect) {
                            return ele.item.getBoundingClientRect().top <= tool_1.getPxByRem(topValue_1) + 2;
                        }
                    });
                    if (arr.length > 0) {
                        _this.setState({
                            activeTab: arr[arr.length - 1].link
                        });
                    }
                }
                else {
                    _this.setState({
                        scrollFixed: false
                    });
                }
            }
        };
        _this.closeNav = function (e) {
            e.stopPropagation();
            var dom = e.target;
            if (dom !== _this.openBtn) {
                _this.setState({
                    showList: false
                });
            }
        };
        _this.clickDownArrow = function () {
            _this.setState({
                showList: true
            });
        };
        _this.clickUpArrow = function () {
            _this.setState({
                showList: false
            });
        };
        _this.clickNav = function (link, i) {
            _this.setState({
                activeTab: link,
                showList: false
            });
            var left = _this.itemList[i].offsetLeft - tool_1.getPxByRem(0.75);
            _this.navList.scrollTo(left, 0);
            var _a = _this.props, hasTitle = _a.hasTitle, navFixed = _a.navFixed, moduleMap = _a.moduleMap;
            tool_2.anchorPoint(moduleMap, link, hasTitle, navFixed);
        };
        _this.clickNavItem = function (link, _order) {
            var _a = _this.props, hasTitle = _a.hasTitle, navFixed = _a.navFixed, moduleMap = _a.moduleMap;
            _this.setState({ activeTab: link });
            tool_2.anchorPoint(moduleMap, link, hasTitle, navFixed);
        };
        _this.state = {
            showList: false,
            activeTab: "",
            scrollFixed: false
        };
        return _this;
    }
    Nav.prototype.componentDidMount = function () {
        window.addEventListener("scroll", throttle_1.default(this.scroll, 30));
        document.addEventListener("click", this.closeNav);
    };
    Nav.prototype.componentWillUnmount = function () {
        window.removeEventListener("scroll", this.scroll);
        document.removeEventListener("click", this.closeNav);
    };
    Nav.prototype.sendTSpm = function (order, title) {
        var _a = this.props.spm, activityId = _a.activityId, pageId = _a.pageId, componentType = _a.componentType, site = _a.site;
        var index = this.props.index;
        var params = {
            site: site,
            activityId: activityId,
            pageId: pageId,
            channel: index,
            channelContent: {
                type: componentType,
                order: order,
                content: title
            }
        };
        tyrande_1.sendEzspm(params, {}, false);
    };
    Nav.prototype.render = function () {
        var _this = this;
        var _a = this.props, moduleDetail = _a.moduleDetail, hasTitle = _a.hasTitle, commonProps = _a.commonProps, setTopMap = _a.setTopMap, addModuleMap = _a.addModuleMap, index = _a.index;
        var _b = this.state, showList = _b.showList, activeTab = _b.activeTab, scrollFixed = _b.scrollFixed;
        var isFixed = scrollFixed;
        var module, texts;
        if (moduleDetail) {
            module = moduleDetail.module;
            texts = module.texts;
        }
        return (React.createElement("div", { ref: function (node) {
                if (node) {
                    setTopMap(index, node);
                    addModuleMap(index, node, "#" + commonProps.id);
                }
            } },
            React.createElement(React.Fragment, null, moduleDetail ? (React.createElement("div", { className: ss.navBox },
                React.createElement("div", { className: ss.navWrap + " " + (isFixed ? ss.navFixed : ss.cancelFix), style: { top: isFixed && tool_2.navFixNum(hasTitle) + "rem" } },
                    React.createElement("div", { className: ss.category, ref: function (node) {
                            if (node) {
                                _this.navList = node;
                            }
                        } }, texts &&
                        texts.map(function (item, i) { return (React.createElement("a", { key: i, onClick: function () { return _this.clickNavItem(item.link, i); }, className: activeTab === item.link ? ss.active : "", ref: function (node) {
                                if (node) {
                                    _this.itemList.push(node);
                                }
                            } }, mutil_Language_1.multilingualTextDisplay(item))); })),
                    showList && (React.createElement("div", { className: ss.list },
                        React.createElement("div", { className: ss.all }, texts &&
                            texts.map(function (item, i) { return (React.createElement("a", { key: i, className: activeTab === item.link ? ss.active : "", href: undefined, onClick: function () { return _this.clickNav(item.link, i); } }, mutil_Language_1.multilingualTextDisplay(item))); })),
                        React.createElement("div", { className: ss.upArrow, onClick: this.clickUpArrow },
                            React.createElement("img", { src: arrowPoster })))),
                    React.createElement("div", { className: ss.downArrow, onClick: this.clickDownArrow, ref: function (node) {
                            if (node) {
                                _this.openBtn = node;
                            }
                        } },
                        React.createElement("img", { src: arrowPoster }))))) : (React.createElement("div", { style: { height: "200px" } })))));
    };
    return Nav;
}(React.Component));
exports.default = WithEZSpm_1.default(Nav);
